// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeUserInfo_startItem__Dm4Gh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
}
.ThemeUserInfo_userInfoContainer__rN1Fn p {
  text-align: center;
}

.ThemeUserInfo_userPosition__5-6Yp {
  color: #9a9a9a;
}
.ThemeUserInfo_loginContainer__qvMAX {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.ThemeUserInfo_loginLink__YouK5 {
  width: 100%;
}
.ThemeUserInfo_logoutContainer__BN9tV {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-inline-end: 10px;
}
.ThemeUserInfo_userImgContainer__aMzzx {
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeUserInfo/ThemeUserInfo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".startItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  column-gap: 8px;\r\n}\r\n.userInfoContainer p {\r\n  text-align: center;\r\n}\r\n\r\n.userPosition {\r\n  color: #9a9a9a;\r\n}\r\n.loginContainer {\r\n  width: 100%;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-evenly;\r\n}\r\n.loginLink {\r\n  width: 100%;\r\n}\r\n.logoutContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  padding-inline-end: 10px;\r\n}\r\n.userImgContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"startItem": `ThemeUserInfo_startItem__Dm4Gh`,
	"userInfoContainer": `ThemeUserInfo_userInfoContainer__rN1Fn`,
	"userPosition": `ThemeUserInfo_userPosition__5-6Yp`,
	"loginContainer": `ThemeUserInfo_loginContainer__qvMAX`,
	"loginLink": `ThemeUserInfo_loginLink__YouK5`,
	"logoutContainer": `ThemeUserInfo_logoutContainer__BN9tV`,
	"userImgContainer": `ThemeUserInfo_userImgContainer__aMzzx`
};
export default ___CSS_LOADER_EXPORT___;
